import { handleActions } from 'redux-actions';
import {
  administratorsOptionsSuccess,
  administratorsSuccess,
  administratorSuccess,
  updateAdministratorStatus,
} from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

import initialState from './states';

export default handleActions(
  {
    [administratorsSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [administratorsOptionsSuccess](state, { payload }) {
      return {
        ...state,
        options: payload,
      };
    },
    [administratorSuccess](state, { payload }) {
      return {
        ...state,
        info: {
          ...state.info,
          [payload.administratorID]: payload,
        },
      };
    },
    [updateAdministratorStatus](state, { payload: { administratorID, status } }) {
      return {
        ...state,
        info: {
          ...state.info,
          [administratorID]: {
            ...state.info[administratorID],
            status,
          },
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
